<template>
    <a-config-provider :locale="arcoLocale">
    <div class="container-box">
        <div class="container-box-top">
            <div class="_head">
                <h1>{{ $t('assets.finance_account') }}</h1>
                <div class="button-group">
                    <a-button type="primary" class="button" @click="$emit('topup')">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg" class="">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M6 3C6 2.44772 6.44772 2 7 2H9C9.55229 2 10 2.44772 10 3V6H11.0073C11.864 6 12.3241 7.00701 11.7632 7.65465L8.75593 11.1271C8.35716 11.5876 7.64284 11.5876 7.24407 11.1271L4.23682 7.65465C3.67594 7.00701 4.136 6 4.99275 6H6V3ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12H4Z"
                                  fill="var(--content-white)">
                            </path>
                        </svg>
                        {{ $t('assets.deposit') }}
                    </a-button>
                </div>
            </div>
            <div class="asset-all">
                <div class="_t">
                    <span>{{ $t('assets.total_assets') }}</span>
                    <div @click="visual = !visual">
                        <icon-eye-invisible v-if="visual" class="color-gray" size="16"/>
                        <icon-eye v-else class="color-gray" size="16"/>
                    </div>
                </div>
                <p class="price">
                    {{ visual ? '********' : (total ? $util.thousandSeparator(total,2) : '0.00000000') }} USDT
                </p>
                <p class="convert">
                    ≈ {{symbol}} {{ visual ? '********' : $util.formatFiat(total, symbol_rate, 2) }}
                </p>
            </div>
        </div>
        <!--总览-->
        <div class="content-main-bottom flex align-center jus-bet">
            <div class="btm-left flex flex-column align-start">
                <div class="btm-left-head">
                    <a-tabs default-active-key="1">
                        <a-tab-pane key="1" :title="$t('assets.fund_list')">
                            <div class="flex align-center jus-bet btm-left-head">
                                <div class="flex align-center">
                                    <a-checkbox value="1" @change="checkboxChange">
                                        <span class="font-12 color-gray">{{ $t('assets.hide_zero_assets') }}</span>
                                    </a-checkbox>
                                </div>
                                <div>
                                    <a-input class="search" v-model="searchKeyword" :placeholder="$t('assets.search_currency')">
                                        <template #prefix>
                                            <icon-search/>
                                        </template>
                                    </a-input>
                                </div>
                            </div>
                            <div class="list">
                                <div>
                                    <div class="tab">
                                        <span>{{ $t('assets.coin') }}</span>
                                        <span>{{ $t('assets.total') }}</span>
                                        <span>{{ $t('assets.available') }}</span>
                                        <span>{{ $t('assets.frozen') }}</span>
                                        <span>{{ $t('assets.asset_conversion_btc') }}</span>
                                        <span>{{ $t('assets.operation') }}</span>
                                    </div>
                                    <div class="cell flex align-center jus-bet"
                                         v-for="(item,idx) in list" :key="idx">
                                        <div class="cell-item">
                                            <div class="flex align-center">
                                                <img class="coin-icon" :src="item.icon">
                                                <span class="coin-text">{{ item.symbol }}</span>
                                            </div>
                                        </div>
                                        <div class="cell-item">
                                            <span>{{ formatNumber(item.finance_balance) }}</span>
                                        </div>
                                        <div class="cell-item">
                                            <span>{{ formatNumber(parseFloat(item.finance_balance) - parseFloat(item.lock_finance)) }}</span>
                                        </div>
                                        <div class="cell-item">
                                            <span>{{ formatNumber(item.lock_finance) }}</span>
                                        </div>
                                        <div class="cell-item">
                                            <span>
                                                {{ $util.thousandSeparator(item.finance_balance * item.new_price,2) }}
                                            </span>
                                        </div>
                                        <div class="cell-item">
                                            <a-button class="button-gray" @click="transfeShow = true">{{ $t('assets.transfer') }}</a-button>
                                            <a-button class="button-gray" disabled @click="withdrawShow = true">{{ $t('assets.withdraw') }}</a-button>
                                        </div>
                                    </div>
                                    <not-date v-if="filteredList.length === 0" :height="500"></not-date>
                                    <div class="flex align-center jus-end mt-20 pagination">
                                        <div class="pagination-container">
                                            <span class="total-text">{{ paginationText }}</span>
                                            <a-pagination 
                                                :total="pagination.total" 
                                                :show-total="false"
                                                show-jumper
                                                @change="getList"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="2" :title="$t('assets.wealth_management')">
                            <div class="list" type="list_two">
                                <div>
                                    <div class="top">
                                        <div class="tab">
                                            <span>{{ $t('assets.product_name') }}</span>
                                            <span>{{ $t('assets.coin') }}</span>
                                            <span>{{ $t('assets.position') }}</span>
                                            <span>{{ $t('assets.interest_paid') }}</span>
                                            <span>{{ $t('assets.status') }}</span>
                                            <span>{{ $t('assets.operation') }}</span>
                                        </div>
                                        <div class="cell flex align-center jus-bet" v-for="(item, index) in financeList" :key="index">
                                            <div class="cell-item">
                                                <span>{{ item.product?.name || '--' }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <img :src="require(`@/assets/images/coin/${item.product.buy_currency.symbol.toLowerCase()}.png`)" alt="">
                                                <span>{{ item.product.buy_currency.symbol }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span>{{ formatNumber(item.amount) }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span>{{ formatNumber(item.income) }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span :class="getStatusClass(item.status, false)">
                                                    {{ getStatusText(item.status, false) }}
                                                </span>
                                            </div>
                                            <div class="cell-item">
                                                <span class="cursor color-primary" @click="viewDetail(item.id)">{{ $t('assets.view') }}</span>
                                            </div>
                                        </div>
                                        <div v-if="financeList.length === 0" class="empty-cell">
                                            <span>{{ $t('common.no_data') }}</span>
                                        </div>
                                    </div>
                                    <div class="flex align-center jus-end mt-20 pagination">
                                        <div class="pagination-container">
                                            <span class="total-text">{{ paginationText }}</span>
                                            <a-pagination 
                                                :show-total="false"
                                                show-jumper
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="3" :title="$t('assets.staking_rewards')">
                            <div class="list" type="list_three">
                                <div>
                                    <div class="top">
                                        <div class="tab">
                                            <span>{{ $t('assets.coin') }}</span>
                                            <span>{{ $t('assets.position') }}</span>
                                            <span>{{ $t('assets.interest_paid') }}</span>
                                            <span>{{ $t('assets.status') }}</span>
                                            <span>{{ $t('assets.operation') }}</span>
                                        </div>
                                        <div class="cell flex align-center jus-bet" v-for="(item, index) in stakingList" :key="index">
                                            <div class="cell-item">
                                                <img :src="require(`@/assets/images/coin/${item.product.buy_currency.symbol.toLowerCase()}.png`)" alt="">
                                                <span>{{ item.product.buy_currency.symbol }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span>{{ formatNumber(item.amount) }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span>{{ formatNumber(item.income) }}</span>
                                            </div>
                                            <div class="cell-item">
                                                <span :class="getStatusClass(item.status, true)">
                                                    {{ getStatusText(item.status, true) }}
                                                </span>
                                            </div>
                                            <div class="cell-item">
                                                <span 
                                                    v-if="item.status === 1" 
                                                    class="cursor color-primary" 
                                                    @click="handleRedeem(item)"
                                                >
                                                    {{ $t('easy_earn.redeem') }}
                                                </span>
                                                <span v-else class="color-disabled">--</span>
                                            </div>
                                        </div>
                                        <div v-if="stakingList.length === 0" class="empty-cell">
                                            <span>{{ $t('common.no_data') }}</span>
                                        </div>
                                    </div>
                                    <div class="flex align-center jus-end mt-20 pagination">
                                        <div class="pagination-container">
                                            <span class="total-text">{{ paginationText }}</span>
                                            <a-pagination 
                                                :show-total="false"
                                                show-jumper
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
            <div class="btm-right">
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.asset_distribution') }}</span>
                    </div>
                    <div class="flex align-center">
                        <div>
                            <v-chart ref="chart" :option="chartOption" :autoresize="true" width="250px"
                                     height="250px" style="width: 250px; height: 250px;"></v-chart>
                        </div>
                    </div>
                </div>
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.fund_flow') }}</span>
                        <span class="seeall">
                            {{ $t('assets.view_all') }}
                            <icon-right />
                        </span>
                    </div>
                    <a-scrollbar class="_list">
                        <div class="_cell" v-for="(item,index) in logList" :key="'l'+item.id">
                            <div class="_item">
                                <span>{{types[item.type]}}</span>
                                <span>{{formatNumber(item.amount)}} {{item.currency.symbol}}</span>
                            </div>
                            <div class="_item">
                                <span>{{item.created_at}} </span>
                                <span class="color-primary">{{ $t('assets.completed') }}</span>
                            </div>
                        </div>
                    </a-scrollbar>
                    <not-date :height="300"></not-date>
                </div>
            </div>
        </div>
    </div>
    <!--    资金划转-->
    <funds-transfe :visible="transfeShow" @close="transfeShow = false"></funds-transfe>
    <!--    充值-->
    <up-trigget :visible="upShow" @close="upShow = false"></up-trigget>
    <!--     提现-->
    <withdraw-trgget :visible="withdrawShow" @click="withdrawShow = false"></withdraw-trgget>
    <!--    赎回方式选择弹窗-->
    <a-modal 
        :visible="redeemVisible" 
        :footer="false" 
        :mask-closable="true"
        :closable="true"
        @cancel="redeemVisible = false"
        :title="$t('easy_earn.redemption_method')"
        width="600px"
        align-center>
        <div class="redeem-modal-content">
            <!-- 赎回方式区域 -->
            <div class="redeem-method-section">
                <div class="redeem-options">
                    <div class="redeem-option" :class="{'selected': redeemType === 1}" @click="redeemType = 1">
                        <div class="option-radio-wrapper">
                            <div class="radio-dot" :class="{'checked': redeemType === 1}">
                                <div class="radio-inner"></div>
                            </div>
                        </div>
                        <div class="option-content">
                            <div class="option-header">
                                <div class="option-title">
                                    <span class="main-text">{{ $t('easy_earn.next_day_settlement') }}</span>
                                    <span class="fee-badge free">{{ $t('easy_earn.no_fee') }}</span>
                                </div>
                            </div>
                            <div class="option-desc">
                                <span>{{ $t('easy_earn.next_day_settlement_description') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="redeem-option" :class="{'selected': redeemType === 0}" @click="redeemType = 0">
                        <div class="option-radio-wrapper">
                            <div class="radio-dot" :class="{'checked': redeemType === 0}">
                                <div class="radio-inner"></div>
                            </div>
                        </div>
                        <div class="option-content">
                            <div class="option-header">
                                <div class="option-title">
                                    <span class="main-text">{{ $t('easy_earn.immediate_settlement') }}</span>
                                    <span class="fee-badge charge">{{ $t('easy_earn.one_percent_redemption_fee') }}</span>
                                </div>
                            </div>
                            <div class="option-desc">
                                <span>{{ $t('easy_earn.immediate_settlement_desc') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="redeem-modal-footer">
                <a-button class="cancel-btn" @click="redeemVisible = false">{{ $t('easy_earn.cancel') }}</a-button>
                <a-button type="primary" class="confirm-btn" @click="confirmRedeem" :loading="redeemLoading">{{ $t('easy_earn.confirm_redemption') }}</a-button>
            </div>
        </div>
    </a-modal>
    <!--    财富管理详情弹窗-->
    <a-modal 
        :visible="detailVisible" 
        :footer="false" 
        :mask-closable="true"
        :closable="true"
        @cancel="detailVisible = false"
        :title="$t('assets.wealth_management_detail')"
        width="600px"
        align-center>
        <div v-if="detailLoading" class="loading-container" style="text-align: center; padding: 40px;">
            <a-spin size="large" />
            <p style="margin-top: 16px;">{{ $t('common.loading') }}</p>
        </div>
        <div v-else-if="detailData" class="detail-content">
            <!-- 产品信息卡片 -->
            <div class="detail-section product-card">
                <div class="section-header">
                    <h3 class="detail-title">{{ $t('assets.product_info') }}</h3>
                </div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.product_name') }}</span>
                        <span class="detail-value highlight">{{ detailData.product?.name || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.annual_return_rate') }}</span>
                        <span class="detail-value return-rate">{{ detailData.product?.eay || '--' }}%</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.term') }}</span>
                        <span class="detail-value">{{ detailData.product?.time_limit || '--' }} {{ $t('investment.days') }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.currency') }}</span>
                        <span class="detail-value currency-badge">
                            <img v-if="detailData.product?.buy_currency?.symbol" 
                                 :src="require(`@/assets/images/coin/${detailData.product.buy_currency.symbol.toLowerCase()}.png`)" 
                                 :alt="detailData.product.buy_currency.symbol"
                                 class="currency-icon">
                            {{ detailData.product?.buy_currency?.symbol || '--' }}
                        </span>
                    </div>
                </div>
            </div>
            
            <!-- 订单信息卡片 -->
            <div class="detail-section order-card">
                <div class="section-header">
                    <h3 class="detail-title">{{ $t('assets.order_info') }}</h3>
                </div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.subscription_amount') }}</span>
                        <span class="detail-value amount-value">{{ formatNumber(detailData.amount) }} {{ detailData.product?.buy_currency?.symbol || '' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.interest_earned') }}</span>
                        <span class="detail-value income-value">{{ formatNumber(detailData.income) }} {{ detailData.product?.buy_currency?.symbol || '' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.purchase_time') }}</span>
                        <span class="detail-value time-value">{{ detailData.created_at || '--' }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="detail-label">{{ $t('assets.status') }}</span>
                        <span class="detail-value">
                            <span v-if="detailData.status === 0" class="status-badge status-pending">{{ $t('assets.status_pending') }}</span>
                            <span v-else-if="detailData.status === 1" class="status-badge status-active">{{ $t('assets.status_active') }}</span>
                            <span v-else-if="detailData.status === 2" class="status-badge status-cancelled">{{ $t('assets.status_cancelled') }}</span>
                            <span v-else-if="detailData.status === 3" class="status-badge status-redeemed">{{ $t('assets.status_redeemed') }}</span>
                            <span v-else class="status-badge">--</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="empty-container" style="text-align: center; padding: 40px;">
            <a-empty :description="$t('common.no_data')" />
        </div>
    </a-modal>
    </a-config-provider>
</template>
<script>
import notDate from "@/components/notdate/notdate.vue";
import {mapGetters} from "vuex";

import VChart from 'vue-echarts';
import * as echarts from 'echarts/core';
import {
    PieChart
} from 'echarts/charts';
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import upTrigget from "@/components/topUp/topUp.vue";
import withdrawTrgget from "@/components/withdraw/withdraw.vue";
import userApi from "@/common/api/user";
import financingApi from "@/common/api/financing";
import depositApi from "@/common/api/deposit";
echarts.use([PieChart, TooltipComponent, LegendComponent, CanvasRenderer,TitleComponent]);

export default {
    components: {withdrawTrgget, upTrigget, fundsTransfe, notDate,VChart},
    props: {
        balance: {
            type: Array,
            default: [],
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transfeShow: false,
            withdrawShow: false,
            upShow: false,

            visual: false,
            checked: false,
            list: [],
            filteredList: [],
            searchKeyword: '',
            pagination: {
                total: 0,
                pageSize: 7
            },
            chartOption:{
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'var(--background-secondary)',
                    borderColor: 'var(--border-strength-200)',
                    textStyle: {
                        color: 'var(--content-primary)'
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top:"top",
                    textStyle: {
                        color: 'var(--content-primary)',
                        fontSize: 12
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        label:{
                            show:false
                        },
                        center:['50%','50%'],
                        radius: '50%',
                        data: [
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        }
                    }
                ]
            },
            types:[],
            logList:[],
            financeList: [],
            stakingList: [],
            // 详情弹窗
            detailVisible: false,
            detailData: null,
            detailLoading: false,
            // 赎回相关
            redeemVisible: false,
            redeemType: 1, // 赎回类型：1=延迟赎回（12小时后，无手续费），0=立即赎回（扣除1%手续费，默认值）
            selectedRedeemItem: null,
            redeemLoading: false
        }
    },
    computed:{
        ...mapGetters(['symbol','symbol_rate']),
        
            // ArcoDesign组件的locale配置
    arcoLocale() {
        const currentLang = this.$i18n?.locale || 'en-US';
        if (currentLang === 'en-US') {
            return {
                locale: 'en-US',
                datePicker: {
                    view: {
                        month: 'Month',
                        year: 'Year',
                        week: 'Week',
                        day: 'Day'
                    },
                    month: {
                        long: {
                            January: 'January',
                            February: 'February',
                            March: 'March',
                            April: 'April',
                            May: 'May',
                            June: 'June',
                            July: 'July',
                            August: 'August',
                            September: 'September',
                            October: 'October',
                            November: 'November',
                            December: 'December'
                        },
                        short: {
                            January: 'Jan',
                            February: 'Feb',
                            March: 'Mar',
                            April: 'Apr',
                            May: 'May',
                            June: 'Jun',
                            July: 'Jul',
                            August: 'Aug',
                            September: 'Sep',
                            October: 'Oct',
                            November: 'Nov',
                            December: 'Dec'
                        }
                    },
                    week: {
                        long: {
                            self: 'Week',
                            monday: 'Monday',
                            tuesday: 'Tuesday',
                            wednesday: 'Wednesday',
                            thursday: 'Thursday',
                            friday: 'Friday',
                            saturday: 'Saturday',
                            sunday: 'Sunday'
                        },
                        short: {
                            self: 'Week',
                            monday: 'Mon',
                            tuesday: 'Tue',
                            wednesday: 'Wed',
                            thursday: 'Thu',
                            friday: 'Fri',
                            saturday: 'Sat',
                            sunday: 'Sun'
                        }
                    },
                    placeholder: {
                        date: 'Please select date',
                        week: 'Please select week',
                        month: 'Please select month',
                        year: 'Please select year',
                        quarter: 'Please select quarter',
                        time: 'Please select time'
                    },
                    rangePlaceholder: {
                        date: ['Start date', 'End date'],
                        week: ['Start week', 'End week'],
                        month: ['Start month', 'End month'],
                        year: ['Start year', 'End year'],
                        quarter: ['Start quarter', 'End quarter'],
                        time: ['Start time', 'End time']
                    },
                    selectTime: 'Select time',
                    selectDate: 'Select date',
                    today: 'Today',
                    now: 'Now',
                    ok: 'OK'
                },
                pagination: {
                    total: 'Total {total} items',
                    goto: 'Go to',
                    page: 'Page',
                    prev: 'Previous',
                    next: 'Next'
                }
            };
        }
        return {
            locale: 'zh-CN',
            datePicker: {
                view: {
                    month: '月',
                    year: '年',
                    week: '周',
                    day: '日'
                },
                month: {
                    long: {
                        January: '一月',
                        February: '二月',
                        March: '三月',
                        April: '四月',
                        May: '五月',
                        June: '六月',
                        July: '七月',
                        August: '八月',
                        September: '九月',
                        October: '十月',
                        November: '十一月',
                        December: '十二月'
                    },
                    short: {
                        January: '1月',
                        February: '2月',
                        March: '3月',
                        April: '4月',
                        May: '5月',
                        June: '6月',
                        July: '7月',
                        August: '8月',
                        September: '9月',
                        October: '10月',
                        November: '11月',
                        December: '12月'
                    }
                },
                week: {
                    long: {
                        self: '周',
                        monday: '星期一',
                        tuesday: '星期二',
                        wednesday: '星期三',
                        thursday: '星期四',
                        friday: '星期五',
                        saturday: '星期六',
                        sunday: '星期日'
                    },
                    short: {
                        self: '周',
                        monday: '一',
                        tuesday: '二',
                        wednesday: '三',
                        thursday: '四',
                        friday: '五',
                        saturday: '六',
                        sunday: '日'
                    }
                },
                placeholder: {
                    date: '请选择日期',
                    week: '请选择周',
                    month: '请选择月份',
                    year: '请选择年份',
                    quarter: '请选择季度',
                    time: '请选择时间'
                },
                rangePlaceholder: {
                    date: ['开始日期', '结束日期'],
                    week: ['开始周', '结束周'],
                    month: ['开始月份', '结束月份'],
                    year: ['开始年份', '结束年份'],
                    quarter: ['开始季度', '结束季度'],
                    time: ['开始时间', '结束时间']
                },
                selectTime: '选择时间',
                selectDate: '选择日期',
                today: '今天',
                now: '此刻',
                ok: '确定'
            },
            pagination: {
                total: '共 {total} 条',
                goto: '前往',
                page: '页'
            }
        };
    },
        
        // 自定义分页显示文本
        paginationText() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return `Total ${this.pagination.total} items`;
            }
            return `共 ${this.pagination.total} 条`;
        }
    },
    watch: {
        // 监听搜索关键词变化
        searchKeyword() {
            this.filterData();
        }
    },
    mounted() {
        this.pagination.total = this.balance.length
        this.getList(1);
        this.filterData();
        this.getFundLogList();
        this.getFinanceData();
        // 延迟更新图表，确保DOM完全渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.updateChart();
            }, 100);
        });
    },
    methods: {
        updateChart() {
            // 确保DOM元素存在且已渲染
            this.$nextTick(() => {
                var data = [];
                this.balance.map((item)=>{
                    if(item.finance_balance > 0){
                        data.push({
                            value:parseFloat(item.finance_balance),
                            name:item.symbol
                        });
                    }
                });
                this.chartOption['series'][0]['data'] = data;
                
                // 强制更新图表
                setTimeout(() => {
                    if (this.$refs.chart) {
                        this.$refs.chart.resize();
                    }
                }, 50);
            });
        },
        getFundLogList(){
            userApi.getCpitalFlow({
                account:5,
                start_at:"",
                end_at:"",
                currency_id:0,
                type:0,
                page:1
            }).then(res=>{
                console.log(res);
                let types = [];
                res.data.types.map((item)=>{
                    types[item.value] = item.label;
                });
                this.types = types;
                this.logList = res.data.list;
            })
        },
        checkboxChange(e) {
            this.checked = e;
            this.filterData();
        },
        getList(c) {
            const startIndex = this.pagination.pageSize * (c - 1);
            const endIndex = startIndex + this.pagination.pageSize;
            this.list = this.filteredList.slice(startIndex, endIndex);
        },
        formatNumber(value) {
            if (!value || parseFloat(value) === 0) {
                return '0.00';
            }
            const num = parseFloat(value);
            // 去除末尾的0，但保留至少2位小数
            return num.toFixed(8).replace(/\.?0+$/, '').replace(/^(\d+\.\d{1})$/, '$10');
        },
        filterData() {
            let filtered = this.balance;

            // 搜索过滤
            if (this.searchKeyword.trim()) {
                filtered = filtered.filter(item =>
                    item.symbol.toLowerCase().includes(this.searchKeyword.toLowerCase())
                );
            }

            // 隐藏0资产过滤 - 只隐藏理财账户余额为0的资产
            if (this.checked) {
                filtered = filtered.filter(item => parseFloat(item.finance_balance || 0) > 0);
            }

            // 按余额从高到低排序
            filtered.sort((a, b) => parseFloat(b.finance_balance || 0) - parseFloat(a.finance_balance || 0));

            this.filteredList = filtered;
            this.pagination.total = filtered.length;
            this.getList(1); // 重置到第一页
        },
        handleSearch() {
            this.filterData();
        },
        getFinanceData() {
            console.log('开始获取理财数据...');
            
            // 并行请求两个接口
            Promise.all([
                financingApi.buyList({page: 1}),
                depositApi.list({page: 1})
            ]).then(([financeRes, depositRes]) => {
                console.log('理财产品API响应:', financeRes);
                console.log('质押生息API响应:', depositRes);
                
                // 处理理财产品数据
                if (financeRes && financeRes.success && financeRes.data && financeRes.data.list) {
                    console.log('理财产品原始数据列表:', financeRes.data.list);
                    
                    // 根据产品名称正确分类数据
                    // 状态说明：0=待确认，1=正常持有，2=撤销，3=已提取（到期）
                    // 理财产品显示状态为1（正常持有）和3（已提取/到期）的记录
                    this.financeList = financeRes.data.list.filter(item => {
                        // 检查基本字段是否存在
                        if (!item.product || 
                            !item.product.name || 
                            !item.product.buy_currency || 
                            !item.product.buy_currency.symbol) {
                            console.log('字段缺失，跳过:', item);
                            return false;
                        }
                        // 显示状态为1（正常持有）和3（已提取/到期）的记录
                        if (item.status !== 1 && item.status !== 3) {
                            console.log('状态不是1或3，跳过:', item.status, item);
                            return false;
                        }
                        
                        // 确保金额字段存在
                        if (!item.amount) item.amount = '0.00';
                        if (!item.income) item.income = '0.00';
                        
                        const productName = item.product.name;
                        console.log('检查产品名称:', productName, '状态:', item.status, '完整数据:', item);
                        
                        // 检查是否包含财富管理相关关键词
                        // 放宽条件：包含理财、定期、财富管理等关键词，或者排除质押相关
                        const isPledgeProduct = productName.includes('质押生息') || 
                                               productName.includes('Staking') || 
                                               productName.includes('staking') ||
                                               productName.toLowerCase().includes('质押') ||
                                               productName.includes('生息');
                        
                        // 如果是质押产品，不显示在财富管理中
                        if (isPledgeProduct) {
                            console.log('是质押产品，不显示在财富管理:', productName);
                            return false;
                        }
                        
                        // 财富管理显示所有非质押的定期理财产品
                        // 包含理财、定期、财富、稳健、高收益等关键词，或者不包含质押关键词
                        const isFinanceProduct = productName.includes('理财') || 
                                                productName.includes('定期') || 
                                                productName.includes('财富') ||
                                                productName.includes('稳健') ||
                                                productName.includes('高收益') ||
                                                productName.includes('Benfu') || 
                                                productName.includes('benfu') ||
                                                productName.includes('版本') ||
                                                productName.includes('乐享') ||
                                                productName.includes('Finance') ||
                                                productName.includes('finance');
                        
                        if (isFinanceProduct) {
                            console.log('是财富管理产品:', productName);
                            return true;
                        }
                        
                        // 如果都不匹配，也显示（可能是其他类型的理财产品）
                        console.log('未匹配关键词，但显示:', productName);
                        return true;
                    });
                    
                    console.log('理财产品数据:', this.financeList);
                } else {
                    console.log('理财产品API响应异常:', financeRes);
                    this.financeList = [];
                }
                
                // 处理质押生息数据
                // 返回格式: { success: true, data: { list: [...] } }
                // 状态说明：1=计息中，2=结束，3=赎回
                if (depositRes && depositRes.success && depositRes.data && depositRes.data.list) {
                    console.log('质押生息原始数据列表:', depositRes.data.list);
                    
                    this.stakingList = depositRes.data.list.map(item => {
                        // 确保金额字段存在
                        if (!item.amount) item.amount = '0.00';
                        
                        // 适配数据结构到统一格式
                        // deposit接口返回格式：{ id, amount, status, currency: { symbol, icon }, did, ... }
                        return {
                            id: item.id,
                            did: item.did, // 质押项目ID，用于赎回
                            amount: item.amount || '0.00',
                            income: '0.00', // deposit接口没有income字段，暂时显示0.00，后续可能需要从其他接口获取
                            status: item.status || 1,
                            created_at: item.created_at || '--',
                            product: {
                                name: '质押生息', // deposit接口没有产品名称，使用固定名称
                                buy_currency: {
                                    symbol: item.currency?.symbol || 'USDT',
                                    icon: item.currency?.icon || null
                                }
                            }
                        };
                    }).filter(item => {
                        // 检查基本字段是否存在
                        if (!item.product || !item.product.buy_currency || !item.product.buy_currency.symbol) {
                            return false;
                        }
                        // 显示状态为1（计息中）和3（赎回）的记录
                        // 状态2（结束）不显示
                        if (item.status !== 1 && item.status !== 3) return false;
                        return true;
                    });
                    
                    console.log('质押生息数据:', this.stakingList);
                } else {
                    console.log('质押生息API响应异常:', depositRes);
                    this.stakingList = [];
                }
            }).catch(error => {
                console.error('获取理财数据失败:', error);
                // 发生错误时，清空列表
                this.financeList = [];
                this.stakingList = [];
            });
        },
        async viewDetail(id) {
            if (!id) {
                this.$message.warning(this.$t('common.error'));
                return;
            }
            
            this.detailVisible = true;
            this.detailLoading = true;
            this.detailData = null;
            
            try {
                console.log('获取财富管理详情，ID:', id);
                const response = await financingApi.buyDetail({ id });
                console.log('财富管理详情响应:', response);
                
                if (response && response.success && response.data) {
                    this.detailData = response.data;
                    console.log('财富管理详情数据:', this.detailData);
                } else {
                    this.$message.error(response?.message || this.$t('common.get_market_data_failed'));
                    this.detailVisible = false;
                }
            } catch (error) {
                console.error('获取财富管理详情失败:', error);
                this.$message.error(this.$t('common.get_market_data_failed'));
                this.detailVisible = false;
            } finally {
                this.detailLoading = false;
            }
        },
        handleRedeem(item) {
            // 只有状态为1（计息中）的才能赎回
            if (!item || item.status !== 1) {
                this.$message.warning(this.$t('easy_earn.no_redeemable_balance'));
                return;
            }
            
            // 使用当前订单的id作为did（订单ID）
            if (!item.id) {
                this.$message.error(this.$t('investment.invalid_redemption_order'));
                return;
            }
            
            // 保存选中的赎回项，使用订单的id
            this.selectedRedeemItem = {
                ...item,
                orderId: item.id // 使用订单的id作为did
            };
            this.redeemType = 1; // 默认延迟赎回（12小时后，无手续费），0=立即赎回（扣除1%手续费，接口默认值）
            this.redeemVisible = true;
        },
        /**
         * 确认赎回
         * 调用接口: POST https://api.dbgm-hk.com/api/deposit/back
         * 
         * 参数说明:
         * - did: 质押订单ID（必填，使用当前订单的id字段）
         * - type: 赎回类型（可选，默认0）
         *   - 0: 立即赎回（扣除1%手续费）
         *   - 1: 延迟赎回（12小时后，无手续费）
         */
        async confirmRedeem() {
            if (!this.selectedRedeemItem || !this.selectedRedeemItem.orderId) {
                this.$message.error(this.$t('investment.invalid_redemption_order'));
                return;
            }
            
            try {
                this.redeemLoading = true;
                const orderId = this.selectedRedeemItem.orderId; // 使用订单的id
                console.log('赎回请求，did（订单ID）:', orderId, 'type:', this.redeemType);
                
                // 调用赎回接口: POST /api/deposit/back
                // 使用当前订单的id作为did，而不是固定的值
                // type: 0=立即赎回（扣除1%手续费，默认值），1=延迟赎回（12小时后，无手续费）
                const response = await depositApi.redeem({
                    did: orderId,
                    type: this.redeemType
                });
                
                console.log('赎回响应:', response);
                
                if (response && response.code === 200) {
                    this.$message.success(this.$t('easy_earn.redemption_submitted_success'));
                    // 关闭弹窗
                    this.redeemVisible = false;
                    // 刷新列表
                    this.getFinanceData();
                } else {
                this.$message.error(response?.message || this.$t('easy_earn.redemption_failed_retry'));
                }
            } catch (error) {
                console.error('赎回失败:', error);
                this.$message.error(this.$t('easy_earn.redemption_failed_retry'));
            } finally {
                this.redeemLoading = false;
            }
        },
        getStatusText(status, isDeposit = false) {
            // 理财产品状态说明：0=待确认，1=正常持有，2=撤销，3=已提取
            // 质押生息状态说明：1=计息中，2=结束，3=赎回
            if (isDeposit) {
                // 质押生息状态
                if (status === 1) {
                    return this.$t('assets.status_earning');
                } else if (status === 2) {
                    return this.$t('assets.status_ended');
                } else if (status === 3) {
                    return this.$t('assets.status_redeemed');
                }
            } else {
                // 理财产品状态
                if (status === 0) {
                    return this.$t('assets.status_pending');
                } else if (status === 1) {
                    return this.$t('assets.status_active');
                } else if (status === 2) {
                    return this.$t('assets.status_cancelled');
                } else if (status === 3) {
                    return this.$t('assets.status_redeemed');
                }
            }
            return '--';
        },
        getStatusClass(status, isDeposit = false) {
            if (isDeposit) {
                // 质押生息状态样式
                if (status === 1) {
                    return 'status-active'; // 计息中 - 绿色
                } else if (status === 2) {
                    return 'status-cancelled'; // 结束 - 灰色
                } else if (status === 3) {
                    return 'status-redeemed'; // 赎回 - 灰色
                }
            } else {
                // 理财产品状态样式
                if (status === 0) {
                    return 'status-pending';
                } else if (status === 1) {
                    return 'status-active';
                } else if (status === 2) {
                    return 'status-cancelled';
                } else if (status === 3) {
                    return 'status-redeemed';
                }
            }
            return '';
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./investmentAccount.scss";

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.total-text {
    color: var(--color-text-2);
    font-size: 14px;
}

// 详情弹窗样式 - 重新设计
.detail-content {
    padding: 0;
    max-height: 70vh;
    overflow-y: auto;
}

.detail-section {
    margin-bottom: 20px;
    background: var(--background-secondary);
    border-radius: 12px;
    padding: 20px;
    transition: all 0.3s ease;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    &.product-card {
        background: linear-gradient(135deg, var(--background-secondary) 0%, rgba(var(--color-primary-rgb, 0, 168, 255), 0.05) 100%);
        border: 1px solid rgba(var(--color-primary-rgb, 0, 168, 255), 0.1);
    }
    
    &.order-card {
        background: var(--background-secondary);
        border: 1px solid var(--border-strength-100);
    }
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
}

.section-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid var(--border-strength-200);
}

.detail-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--content-primary);
    margin: 0;
    display: flex;
    align-items: center;
    
    &::before {
        content: '';
        width: 4px;
        height: 18px;
        background: var(--color-primary);
        border-radius: 2px;
        margin-right: 10px;
    }
}

.detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    background: var(--background-primary);
    border-radius: 8px;
    border: 1px solid var(--border-strength-100);
    transition: all 0.2s ease;
    
    &:hover {
        background: var(--background-secondary);
        border-color: var(--border-strength-200);
    }
}

.detail-label {
    font-size: 13px;
    color: var(--color-text-2);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.7;
}

.detail-value {
    font-size: 16px;
    color: var(--content-primary);
    font-weight: 600;
    word-break: break-word;
    
    &.highlight {
        font-size: 18px;
        color: var(--color-primary);
        font-weight: 700;
    }
    
    &.return-rate {
        font-size: 20px;
        color: var(--color-success);
        font-weight: 700;
    }
    
    &.amount-value {
        font-size: 18px;
        color: var(--content-primary);
        font-weight: 700;
    }
    
    &.income-value {
        font-size: 18px;
        color: var(--color-success);
        font-weight: 700;
    }
    
    &.time-value {
        font-size: 14px;
        color: var(--color-text-2);
        font-weight: 500;
    }
    
    &.currency-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 12px;
        background: var(--background-secondary);
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
    }
}

.currency-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.status-badge {
    display: inline-block;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    min-width: 80px;
    
    &.status-pending {
        background: rgba(var(--color-warning-rgb, 255, 193, 7), 0.15);
        color: var(--color-warning);
        border: 1px solid rgba(var(--color-warning-rgb, 255, 193, 7), 0.3);
    }
    
    &.status-active {
        background: rgba(var(--color-success-rgb, 0, 200, 83), 0.15);
        color: var(--color-success);
        border: 1px solid rgba(var(--color-success-rgb, 0, 200, 83), 0.3);
    }
    
    &.status-cancelled {
        background: rgba(var(--color-text-3-rgb, 150, 150, 150), 0.15);
        color: var(--color-text-3);
        border: 1px solid rgba(var(--color-text-3-rgb, 150, 150, 150), 0.3);
    }
    
    &.status-redeemed {
        background: rgba(var(--color-text-2-rgb, 120, 120, 120), 0.15);
        color: var(--color-text-2);
        border: 1px solid rgba(var(--color-text-2-rgb, 120, 120, 120), 0.3);
    }
}
</style>
